import React from 'react'
import RowButton from 'components/atoms/row-button'
import PropTypes from 'prop-types'
import InternalRequestItemStatusBadge from 'domains/internal-request/atoms/item-status-badge'
import InternalRequestService from 'domains/internal-request/services'

const actionCellPropTypes = {
  cell: PropTypes.shape({
    row: PropTypes.shape({
      original: PropTypes.object
    })
  })
}

const propTypes = {
  rowButtonProps: PropTypes.arrayOf(PropTypes.object)
}


const defaultProps = {
  rowButtonProps: []
}

const QuantityToBorrowCell = ({ cell: { row } }) => {
  let data      = row.original
  let inventory = data.inventory

  return InternalRequestService.getQuantityToBorrow(inventory.stored_quantity, inventory.sellable_quantity)
}

const LocationCell = (row) => {
  let inventoryLocations = row.cell.value

  return (
    inventoryLocations.map((inventoryLocation, index) => (
      <div key={ index }>{ `${inventoryLocation.location} [${inventoryLocation.sublocation}]` }</div>
    ))
  )
}

const ImageCell = (row) => <img style={{ width: '8rem' }} src={ row.cell.value } alt={ row.row.original.inventory.product.name } />

const generateActionCell = (rowButtonProps) => {

  const buttons = rowButtonProps.map((button) => {

    const ActionCell = ({ cell: { row } }) => {

      const disabled = button.isDisabled ? button.isDisabled(row.original) : false

      return (
        <div className='text-center'>
          <RowButton
            data={ row.original }
            color={ button.colour }
            disabled={ disabled }
            onClick={ button.onClick }
            text={ button.text }
          />
        </div>
      )
    }
    ActionCell.propTypes = actionCellPropTypes

    return {
      Header : button.header,
      id     : button.id,
      Cell   : ActionCell
    }
  })

  return buttons
}


const StatusCell = (row) => <InternalRequestItemStatusBadge status={ row.cell.value } />

/**
 * Columns definition for Seller Product Table
 * @param {array} rowButtonProps - Array props for row button
 */
const InternalRequestItemTableColumns = ({ rowButtonProps }) => (
  [
    {
      Header         : 'Image',
      id             : 'image',
      accessor       : 'inventory.product.main_image',
      Cell           : ImageCell,
      disableFilters : true
    },
    {
      Header   : 'SKU',
      id       : 'inventory_sku',
      accessor : 'inventory.inventory_sku'
    },
    {
      Header         : 'Name',
      id             : 'name',
      accessor       : 'inventory.product.name',
      disableFilters : true
    },
    {
      Header         : 'Size',
      id             : 'size',
      accessor       : 'inventory.product_dimension.size',
      disableFilters : true
    },
    {
      Header         : 'Status',
      id             : 'status',
      accessor       : 'status',
      disableFilters : true,
      Cell           : StatusCell
    },
    {
      Header         : 'Quantity',
      id             : 'quantity',
      accessor       : 'quantity',
      disableFilters : true
    },
    {
      Header         : <>Quantity<br/>Requested</>,
      id             : 'quantity_requested',
      accessor       : 'quantity',
      disableFilters : true
    },
    {
      Header         : <>Quantity<br/>Picked</>,
      id             : 'quantity_picked',
      accessor       : 'quantity_picked',
      disableFilters : true
    },
    {
      Header         : <>Quantity<br/>Borrowed</>,
      id             : 'borrowed',
      accessor       : 'quantity',
      disableFilters : true
    },
    {
      Header         : <>Quantity Marked<br/>for Return</>,
      id             : 'marked_for_return',
      accessor       : 'quantity_marked_for_return',
      disableFilters : true
    },
    {
      Header         : <>Quantity Available<br/>to Borrow</> ,
      id             : 'quantity_to_borrow',
      Cell           : QuantityToBorrowCell,
      disableFilters : true
    },
    {
      Header         : <>Quantity<br/>in Warehouse</>,
      id             : 'quantity_in_warehouse',
      accessor       : 'inventory.stored_quantity',
      disableFilters : true
    },
    {
      Header         : <>Quantity<br/>Put Away</>,
      id             : 'quantity_put_away',
      accessor       : 'quantity_put_away',
      disableFilters : true
    },
    {
      Header         : <>Quantity<br/>Returned</>,
      id             : 'returned',
      accessor       : 'quantity_returned',
      disableFilters : true
    },
    {
      Header         : <>Quantity<br/>Unreturned</>,
      id             : 'unreturned',
      accessor       : 'quantity_permanently_borrowed',
      disableFilters : true
    },
    {
      Header         : 'Location',
      id             : 'location',
      accessor       : 'inventory.inventory_locations',
      Cell           : LocationCell,
      disableFilters : true
    },
    {
      Header         : 'Reason',
      id             : 'reject_reason',
      accessor       : 'reject_reason',
      disableFilters : true
    },
    {
      Header         : 'Reject Note',
      accessor       : 'reject_note',
      disableFilters : true
    },
    {
      Header  : 'Actions',
      columns : [
        // * Generate action cell with buttonProps
        ...generateActionCell(rowButtonProps)
      ]
    }
  ]
)

InternalRequestItemTableColumns.propTypes    = propTypes
InternalRequestItemTableColumns.defaultProps = defaultProps

export default InternalRequestItemTableColumns
